module.exports = __webpack_public_path__ + "media/assets/icons/lightning-77ddde2578abafba7654a18508f87162.svg";